import { defineMessages } from 'react-intl';

import { Sections } from '../../constants';

export const PROFILE_TAB_KEY = '@@profileTab';

export const LOCALIZED_STRINGS = defineMessages({
    ShowMore: {
        id: 'Profile.Components.ProfileTab.Memberships.ShowMore',
        defaultMessage: 'view all',
    },
    ShowFewer: {
        id: 'Profile.Components.ProfileTab.Memberships.ShowFewer',
        defaultMessage: 'show fewer',
    },
    DataProvidedBy: {
        id: 'Profile.Page.Components.DataProvidedBy',
        defaultMessage: '* Data provided by ',
    },
    ReadMore: {
        id: 'Profile.Page.Components.ProfileTab.Statement.ReadMore',
        defaultMessage: 'read more',
    },
});

export const LOCALIZED_HEADERS = defineMessages({
    [Sections.Awards]: {
        id: 'Profile.Components.ProfileTab.Awards.Header',
        defaultMessage: 'Awards and publications',
    },
    [Sections.Badges]: {
        id: 'Profile.Components.ProfileTab.Badges.Header',
        defaultMessage: 'Zocdoc recognition',
    },
    [Sections.Badges1Z]: {
        id: 'Profile.Components.ProfileTab.Badges.Header.1Z',
        defaultMessage: 'Zocdoc awards',
    },
    [Sections.Certifications]: {
        id: 'Profile.Components.ProfileTab.Certifications.Header',
        defaultMessage: 'Board certifications',
    },
    [Sections.Education]: {
        id: 'Profile.Components.ProfileTab.Education.Header',
        defaultMessage: 'Education and training',
    },
    [Sections.HospitalAffiliations]: {
        id: 'Profile.Components.ProfileTab.HospitalAffiliations.Header',
        defaultMessage: 'Hospital affiliations',
    },
    [Sections.Institutes]: {
        id: 'Profile.Components.ProfileTab.Institutes.Header',
        defaultMessage: 'Institutes',
    },
    [Sections.InNetworkInsurance]: {
        id: 'Profile.Components.ProfileTab.InNetworkInsurance.Header',
        defaultMessage: 'In-network insurances',
    },
    [Sections.InNetworkInsuranceMobile1Z]: {
        id: 'Profile.Components.ProfileTab.InNetworkInsurance.Header.1Z',
        defaultMessage: 'Is this doctor in your insurance network?',
    },
    [Sections.Languages]: {
        id: 'Profile.Components.ProfileTab.Languages.Header',
        defaultMessage: 'Languages spoken',
    },
    [Sections.Memberships]: {
        id: 'Profile.Components.ProfileTab.Memberships.Header',
        defaultMessage: 'Professional memberships',
    },
    [Sections.NPI]: {
        id: 'Profile.Components.ProfileTab.NPI.Header',
        defaultMessage: 'NPI number',
    },
    [Sections.OfficeLocation]: {
        id: 'Profile.Components.ProfileTab.OfficeLocation.Header',
        defaultMessage: 'Office location',
    },
    [Sections.Practice]: {
        id: 'Profile.Components.ProfileTab.Practice.Header',
        defaultMessage: 'Practice names',
    },
    [Sections.Sex]: {
        id: 'Profile.Components.ProfileTab.Sex.Header',
        defaultMessage: 'Provider\'s gender',
    },
    [Sections.Specialties]: {
        id: 'Profile.Components.ProfileTab.Specialties.Header',
        defaultMessage: 'Specialties',
    },
    [Sections.Statement]: {
        id: 'Profile.Components.ProfileTab.Statement.Header',
        defaultMessage: 'Professional statement',
    },
    [Sections.Titles]: {
        id: 'Profile.Components.ProfileTab.Titles.Header',
        defaultMessage: 'Titles',
    },
});

/* NOTE: This lookup table exists because directory-service returns the provider's sex using a legacy enum */
export const Sex = {
    Male: 1,
    Female: 2,
};

export const LOCALIZED_SEX = defineMessages({
    [Sex.Male]: {
        id: 'Profile.Components.ProfileTab.Sex.Male',
        defaultMessage: 'Male',
    },
    [Sex.Female]: {
        id: 'Profile.Components.ProfileTab.Sex.Female',
        defaultMessage: 'Female',
    },
});
